import { getConstant } from '../utils';

export const getCalculatorsSoilComposition = getConstant('GET_CALCULATORS_SOIL_COMPOSITION');
export const getCalculatorsSoilCompositionItem = getConstant('GET_CALCULATORS_SOIL_COMPOSITION_ITEM');